import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Dashboard from "./Dashboard";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-dashboard")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Dashboard />
		</ThemeProvider>
	</StrictMode>
);
